import styled from "styled-components/macro";

export const TagsPanel = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-bottom: 40px;
    
  @media (max-width: 979px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
`;

export const TagButton = styled.button<{ isActive: boolean }>`
  height: 40px;
  padding: 0 20px;
  border-radius: 20px;
  background-color: ${({ isActive }) => (isActive ? "#BFDCF5" : "#fff")};
  ${({ isActive }) => isActive
    ? "border: 1px solid #BFDCF5;"
    : "border: 1px solid #141414;"}
  cursor: pointer;
  font-weight: 500;
  font-size: 18px;
  transition: 0.2s;
  white-space: nowrap;

  &:hover {
    background-color: #141414;
    color: #fff;
  }
    
  @media (max-width: 979px) {
    font-size: 16px;
  }
`;

export const CardsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
`;
